<div class="page-banner-area">
    <div class="container">
        <div class="page-banner-content">
            <h2>Upcoming Events</h2>
        </div>
    </div>
</div>
<div class="events-schedules-area-with-color ptb-50 mb-4 mt-5">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-4 col-md-6  mb-3" *ngFor="let item of eventsList">
                <div class="events-content-box">
                    <img class="eventimage" src="{{imgURL}}{{item?.image}}">
                    <div class="event-details mt-3">
                        <div class="locationdetails">
                          <i class='bx bx-calendar'></i>
                          <p>
                            <span>{{item?.event_start_datetime | date:dateTimeFormat}} - {{item?.event_end_datetime | date:dateTimeFormat}}</span> 
                          </p>
                        </div>
                        <div class="locationdetails">
                          <i class='bx bx-location-plus'></i>
                            <p>
                              <span *ngIf="item?.address1">{{item?.address1 }}, </span>
                              <span *ngIf="item?.address2"> {{ item?.address2 }}</span>
                              <span *ngIf="item?.city">{{item?.city }}, </span>
                              <span *ngIf="item?.state">{{item?.state }}, </span>
                              <span *ngIf="item?.zipcode">{{ item?.zipcode }} </span>
                            </p>
                        </div>
                    </div>
                    <h3><a>{{item?.name}} </a></h3>
                    <!-- <p [class.collapsed]="!item.showFullDescription" [innerHTML]="item.description"></p>
                    <a *ngIf="isTextOverflowing(item)" (click)="toggleDescription(item)" class="toggle-link">
                      {{ item.showFullDescription ? 'Read less' : 'Read more' }}
                    </a> -->
                    <div class="bottom-content">
                        <div class="option-item">
                            <a class="default-btn" [routerLink]="['/services', item.id]"> Event Details<span class="position-absolute"></span></a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<app-aboutandeventform></app-aboutandeventform>
<div class="loader" *ngIf="loader">
    <div id="loading"></div>
</div>
